import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Sun, Clock, Moon, Shield, CheckCircle2 } from 'lucide-react';
export function SolutionSection() {
  const zones = [{
    icon: Sun,
    title: 'Z1 Mañanas',
    desc: 'Para salir sin perder cosas y sin gritos',
    color: 'bg-orange-100 text-orange-600'
  }, {
    icon: Clock,
    title: 'Z2 Tardes',
    desc: 'Para bajar hambre/choque y evitar peleas',
    color: 'bg-blue-100 text-blue-600'
  }, {
    icon: Moon,
    title: 'Z3 Noche',
    desc: 'Para cenar sin pensar y cerrar en 8 minutos',
    color: 'bg-indigo-100 text-indigo-600'
  }, {
    icon: Shield,
    title: 'Z4 Emergencias',
    desc: 'Para que una crisis no te robe 3 días',
    color: 'bg-red-100 text-red-600'
  }];
  return <section className="py-20 px-4" data-id="element-154">
      <div className="max-w-6xl mx-auto" data-id="element-155">
        <FadeIn className="text-center max-w-3xl mx-auto mb-16" data-id="element-156">
          <span className="text-[#C75B3F] font-semibold tracking-wider uppercase text-sm" data-id="element-157">
            La Solución
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mt-3 mb-6" data-id="element-158">
            Tablero 4Z: El sistema anti-caos para días reales
          </h2>
          <p className="text-lg text-stone-600" data-id="element-159">
            En lugar de intentar "organizarlo todo", este sistema divide tu vida
            en 4 zonas que se repiten. En cada zona instalas{' '}
            <span className="font-bold text-stone-800" data-id="element-160">
              mínimos no negociables
            </span>
            : un piso pequeño que puedes sostener incluso en días difíciles.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-161">
          {zones.map((zone, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-162">
              <div className="bg-white p-6 rounded-3xl shadow-sm border border-stone-100 h-full hover:shadow-md transition-shadow" data-id="element-163">
                <div className={`w-12 h-12 rounded-2xl ${zone.color} flex items-center justify-center mb-4`} data-id="element-164">
                  <zone.icon className="w-6 h-6" data-id="element-165" />
                </div>
                <h3 className="text-xl font-bold text-stone-900 mb-2" data-id="element-166">
                  {zone.title}
                </h3>
                <p className="text-stone-600" data-id="element-167">{zone.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn className="bg-[#C75B3F] rounded-3xl p-8 md:p-12 text-white text-center md:text-left" data-id="element-168">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-169">
            <div className="flex-1" data-id="element-170">
              <h3 className="text-2xl font-bold mb-4" data-id="element-171">
                Por qué esto funciona cuando lo demás falla
              </h3>
              <p className="text-orange-100 text-lg mb-6" data-id="element-172">
                Porque no depende de motivación. Depende de un sistema diseñado
                para tu realidad: trabajo, escuela, cansancio, idioma,
                emergencias y crianza sin tribu.
              </p>
              <div className="flex flex-wrap gap-4 justify-center md:justify-start" data-id="element-173">
                {['Fricción reducida', 'Decisión cero', 'Protocolos claros'].map(item => <div key={item} className="flex items-center bg-white/10 px-4 py-2 rounded-full backdrop-blur-sm" data-id="element-174">
                    <CheckCircle2 className="w-4 h-4 mr-2 text-orange-200" data-id="element-175" />
                    <span className="font-medium" data-id="element-176">{item}</span>
                  </div>)}
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}